import { advancedShippingNoticeGridProperties } from '../grid-properties';

export const baseColumnsDefaultConfigs = [
  {
    id: advancedShippingNoticeGridProperties.name,
    minWidth: 100,
    width: 200,
    pinned: false,
    index: 0,
  },
  {
    id: advancedShippingNoticeGridProperties.status,
    minWidth: 100,
    width: 120,
    pinned: false,
    index: 1,
  },
  {
    id: advancedShippingNoticeGridProperties.dateLastUpdated,
    minWidth: 100,
    width: 150,
    pinned: false,
    index: 2,
  },
  {
    id: advancedShippingNoticeGridProperties.dateSubmitted,
    minWidth: 100,
    width: 150,
    pinned: false,
    index: 3,
  },
  {
    id: advancedShippingNoticeGridProperties.dateCreated,
    minWidth: 100,
    width: 150,
    pinned: false,
    index: 4,
  },
  {
    id: advancedShippingNoticeGridProperties.actions,
    minWidth: 100,
    width: 120,
    pinned: false,
    index: 5,
  },
];
